import styles from "./Checkout.module.css";
import chevronLeft from "../../asset/icons/chevronLeft.png";
import whatsappIcon from "../../asset/icons/whatsapp.png";
import forward from "../../asset/icons/whiteForwardCircle.png";
import React, { useState, useEffect } from "react";
import cx from "classnames";
import Api from "../../utils/Api/Api";
import Helper from "../../utils/Helper";
import FleekIcon from "../../asset/icons/Brand_logo_Sq.png";
import { useSearchParams } from "react-router-dom";

import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import { useNavigate } from "react-router-dom";
import chevronRight from "../../asset/icons/chevronRight.png";
import { ToastContainer, toast } from "react-toastify";
import PercentCircle from "../../asset/icons/percentCircle.png";
import GreenPercentCircle from "../../asset/icons/GreenPercent.png";

import "react-toastify/dist/ReactToastify.css";
import { CoupanPopUp, CouponCongrats } from "../../components";

import {
  PaymentDetailsCard,
  UserPersonalDetailsCard,
  ProductPurchaseCard,
  FleekCoinDetailsCard,
  EarnFleekCoinsCard,
} from "../../components";

import UTMTracker from "../../utils/UTMTracker";
import SnapchatPixel from '../../utils/SnapchatPixel';

export const Checkout = ({ coupon = false }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentStatus = searchParams.get("status");
  const isMobile = Helper.isMobile();
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [hasError, setError] = useState(false);
  const [showCoupanPopUp, setShowCoupanPopup] = useState(false);
  const [showCoupanCongratsPopUp, setShowCoupanCongrats] = useState(false);
  const [userDetail, setUserDetail] = useState({ email: "", phone: "" });
  const [cartData, setCartData] = useState([]);
  const [fleekCoins, setFleekCoins] = useState([]);
  const [appliedCoupon, setAppliedCoupon] = useState({});
  // Fleek Coin State
  const [useFleekCoin, setUseFleekCoin] = useState(true);
  const toggleCoupanPopUp = () => {
    if (coupon === true) {
      navigate("/checkout");
      return;
    }
    setShowCoupanPopup((pre_state) => !pre_state);
  };
  const toggleUseFleekCoin = () => {
    setUseFleekCoin((pre_state) => !pre_state);
  };
  const bundleId = localStorage.getItem("bundleId");

  const toggleCoupanCongrats = (data) => {
    setShowCoupanCongrats((pre_state) => !pre_state);
    if (data && data.coupon_code) {
      setAppliedCoupon(data);
    }
  };

  useEffect(() => {
    // Capture UTM parameters when the checkout page loads
    UTMTracker.captureUTMParams();

    const fetchCartData = async () => {
      try {
        const promise = [
          Api.GetFleekCoins(),
          Api.GetUserDetails(),
        ];

        // Separate try-catch for Juspay ID to handle 'already exists' case
        try {
          await Api.CreateJuspayId();
        } catch (err) {
          // Ignore if customer already exists
          if (err?.response?.data?.error_code !== 'unique') {
            console.error("Juspay ID creation failed:", err);
          }
        }

        if (bundleId) {
          const params = {
            bundle: bundleId,
          };
          promise.push(
            Api.BundleCheckout(params),
            Api.BundleDetails({ params: { bundle_id: bundleId } })
          );
        } else {
          promise.push(Api.GetCartItems());
        }
        let [
          { data: fleekCoins },
          { data: userDetails },
          { data },
          bundleDetails,
        ] = await Promise.all(promise);

        // Track InitiateCheckout when cart data is loaded
        if (data) {
          const cartValue = bundleDetails?.data?.[0]?.bundle?.mrp_price ||
            data?.final_payment_amount?.no_coin_and_no_money || 0;
          const currencyType = bundleDetails?.data?.[0]?.bundle?.currency_type ||
            data?.currency_type || 'INR';

          // Track with Facebook Pixel
          window.fbq('track', 'InitiateCheckout', {
            value: cartValue,
            currency: currencyType,
            content_type: 'product',
            num_items: bundleId ? 1 : (data?.length || 0)
          });

          // Track with Snapchat Pixel
          await SnapchatPixel.trackStartCheckout({
            currency_type: currencyType,
            total_amount: cartValue,
            items: bundleId ? [{ id: bundleId }] : data
          });
        }

        if (bundleDetails?.data && bundleDetails.data.length) {
          data = [
            {
              subscription_plan: {
                service_name: "",
                plan_name: bundleDetails.data[0]?.bundle?.name || "",
                image_url: FleekIcon,
                bundle_id: bundleId,
              },
              discount_percentage_on_cost: data.discount_percentage_on_cost,
              actual_discounted_cost:
                data.final_payment_amount.coin_and_no_money,
              coin_used_percentage:
                Number(data.coin_used_percentage || 0) +
                data.discount_percentage_on_cost,
              cost: data.final_payment_amount.no_coin_and_no_money,
              mrp_price: bundleDetails.data[0]?.bundle?.mrp_price,
              coin_value_reserved: data.coin_value_reserved,
            },
          ];
        }
        setCartData(data);
        setFleekCoins(fleekCoins);
        setUserDetail({
          email: userDetails.email,
          phone: userDetails.phone_number,
        });
      } catch (err) {
        setError(true);
      }
      setLoading(false);
    };
    fetchCartData();
  }, []);

  const PlaceOrder = async () => {
    if (!isAbleButton() || buttonLoading) {
      return;
    }

    setButtonLoading(true);

    const payload = {
      screen_type: bundleId ? "bundle" : "buy_once",
      bundle: bundleId,
      use_coins: useFleekCoin,
      os: "web",
      email: userDetail.email,
      discount_coupon_id: appliedCoupon?.id,
      buy_now: bundleId ? true : undefined,
    };

    // Handle phone number based on currency type
    if (currencyType === 'usd') {
      payload.details = {
        user_entered_phone_number: userDetail.phone
      };
    } else {
      payload.phone_number = userDetail.phone;
    }

    try {
      let data = await Api.PlaceOrder(payload);

      if (!(data && data.data)) {
        toast(
          data?.response?.data?.error || "Something went wrong! Please try later."
        );
        setButtonLoading(false);
        return;
      } else {
        data = data.data;
      }

      const payloadPayment = {
        type: "MKP",
        is_fleek_money_used: false,
        currency: "INR",
        new_placed_ordered_id: data.id,
        os: "web",
        // Simple return URL without UTM parameters
        return_url: process.env.REACT_APP_PAYMENT_URL + "/order-confirmation",
      };
      
      // Add logging to debug return URL
      console.log("Return URL being used:", process.env.REACT_APP_PAYMENT_URL + "/order-confirmation");
      
      const { data: paymentData } = await Api.GetPaymentLink(payloadPayment);

      if (paymentData && paymentData.is_purchase_done) {
        // Simple navigation without UTM parameters
        navigate(`/order?order_id=${paymentData.order_id}`);
      } else {
        // Direct redirect to payment URL without UTM parameters
        window.location.href = paymentData.web;
      }
    } catch (error) {
      console.error("Payment processing error:", error);
      toast("An error occurred. Please try again.");
      setButtonLoading(false);
    }
  };

  const RemoveCoupon = async () => {
    const params = {};
    if (bundleId) {
      params.bundle = bundleId;
    }
    const { data } = await Api[bundleId ? "BundleCheckout" : "GetOrderAmount"](
      params
    );
    setAppliedCoupon({ discountDetails: data });
  };
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    // Only apply phone number length restriction for non-USD currency
    if (name === "phone" && value.length > 10 && currencyType !== 'usd') {
      return;
    }
    setUserDetail((pre_state) => {
      return { ...pre_state, [name]: value };
    });
  };
  const eraseInput = (e) => {
    const name = e.target.name;
    setUserDetail((pre_state) => {
      return { ...pre_state, [name]: "" };
    });
  };
  const isAbleButton = () => {
    // For USD currency, only check email
    if (currencyType === 'usd') {
      return userDetail.email?.length > 0;
    }
    // For non-USD currency, check both email and phone number
    return userDetail.email?.length > 0 && userDetail.phone?.length === 10;
  };

  const openWhatsApp = () => {
    window.open(`https://wa.me/919353853270`, '_blank');
  }

  const getCurrencySymbol = (currency_type) => {
    return currency_type === 'usd' ? '$' : '₹';
  }

  // Get currency type from cart data or localStorage
  const currencyType = cartData[0]?.subscription_plan?.currency_type || localStorage.getItem('current_currency_type') || 'inr';
  const currencySymbol = getCurrencySymbol(currencyType);

  if (hasError) {
    return <ErrorFallback />;
  }
  if (loading) {
    return <Loading />;
  }

  let paymentDetails = cartData[0] || {};
  if (appliedCoupon && appliedCoupon.discountDetails && !bundleId) {
    const {
      total_cost: mrp_price,
      total_cost_calculated,
      final_payment_amount,
      coupon_code_value,
    } = appliedCoupon.discountDetails;
    paymentDetails = {
      mrp_price,
      cost: total_cost_calculated,
      actual_discounted_cost: final_payment_amount?.coin_and_no_money,
      coin_value_reserved:
        (final_payment_amount?.no_coin_and_no_money || 0) -
        (final_payment_amount?.coin_and_no_money || 0),
      couponDiscount: coupon_code_value,
    };
  } else if (paymentDetails) {
    paymentDetails.couponDiscount =
      appliedCoupon?.discountDetails?.coupon_code_value || 0;
    paymentDetails.cost =
      appliedCoupon?.discountDetails?.final_payment_amount?.no_coin_and_no_money || paymentDetails.cost;
    paymentDetails.actual_discounted_cost =
      appliedCoupon?.discountDetails?.final_payment_amount?.coin_and_no_money ||
      paymentDetails.actual_discounted_cost;
  }
  return (
    <>
      <ToastContainer />
      {paymentStatus === 'failed' && (
        <div className={styles.paymentFailureBanner}>
          Payment failed. Please try again.
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.header}>
          <p className={cx(styles.headText, styles.mobile)}>Checkout</p>
          <img
            onClick={() => navigate(-1)}
            className={styles.chevronLeft}
            src={chevronLeft}
            alt="chevronLeft"
          />
        </div>
        <div className={styles.detailContainer}>
          <div className={styles.cardContainer}>
            <p className={cx(styles.headText, styles.desktop)}>Checkout</p>
            {cartData.map((d, i) => {
              return (
                <ProductPurchaseCard
                  useFleekCoin={useFleekCoin}
                  isDigital={false}
                  cartData={d}
                  key={i}
                />
              );
            })}
            {/* <FreeProductPurchaseCard/> */}
          </div>
          <div className={styles.otherDetail}>
            <UserPersonalDetailsCard
              userDetail={userDetail}
              handleChange={handleChange}
              eraseInput={eraseInput}
            />
            {cartData[0]?.coin_value_reserved &&
              Number(cartData[0].coin_value_reserved) ? (
              <FleekCoinDetailsCard
                fleekCoins={fleekCoins}
                useFleekCoin={useFleekCoin}
                toggleUseFleekCoin={toggleUseFleekCoin}
                cartData={cartData[0]}
              />
            ) : (
              <EarnFleekCoinsCard />
            )}
            {appliedCoupon.coupon_code ? (
              <div className={styles.appliedCoupanCard}>
                <img
                  src={GreenPercentCircle}
                  alt="GreenPercentCircle"
                  className={styles.circle}
                />
                <div className={styles.textContainer}>
                  <p className={styles.appliedCoupanText}>
                    {appliedCoupon.coupon_code} applied
                  </p>
                  <p className={styles.appliedSubText}>
                    Yay! You saved {currencySymbol}{appliedCoupon.amountSaved}
                  </p>
                </div>
                <p onClick={RemoveCoupon} className={styles.removeText}>
                  REMOVE
                </p>
              </div>
            ) : (
              <div
                onClick={() =>
                  isMobile ? navigate("/coupon") : toggleCoupanPopUp()
                }
                className={styles.applyCoupanCard}
              >
                <img
                  src={PercentCircle}
                  alt="PercentCircle"
                  className={styles.circle}
                />
                <p className={styles.coupantext}>Apply Coupon</p>
                <p className={styles.newText}>NEW</p>
                <img
                  src={chevronRight}
                  alt="chevronRight"
                  className={styles.chevronRight}
                />
              </div>
            )}
            <PaymentDetailsCard
              useFleekCoin={useFleekCoin}
              cartData={paymentDetails}
            />

            {/* Trust badges for increased conversion */}
            <div className={styles.trustBadges}>
              <div className={styles.trustBadge}>
                <span className={styles.trustIcon}>🔒</span>
                <span className={styles.trustText}>100% Secure Payments</span>
              </div>
              <div className={styles.trustBadge}>
                <span className={styles.trustIcon}>✅</span>
                <span className={styles.trustText}>Verified Brands</span>
              </div>
              <div className={styles.trustBadge}>
                <span className={styles.trustIcon}>🎁</span>
                <span className={styles.trustText}>Exclusive Offers</span>
              </div>
            </div>

            {/* WhatsApp Support Card */}
            <div className={styles.whatsappCard} onClick={openWhatsApp}>
              <div className={styles.whatsappContent}>
                <img src={whatsappIcon} alt="WhatsApp" className={styles.whatsappIcon} />
                <div className={styles.whatsappText}>
                  <p className={styles.whatsappTitle}>Having trouble checking out?</p>
                  <p className={styles.whatsappSubtitle}>WhatsApp us now</p>
                  <p className={styles.whatsappNumber}>+91 93538 53270</p>
                </div>
              </div>
              <img src={forward} alt="forward" className={styles.whatsappForward} />
            </div>

            <div className={styles.mobileButtonContainer}>
              <button
                onClick={PlaceOrder}
                className={
                  isAbleButton()
                    ? buttonLoading ? cx(styles.payButton, styles.loading) : styles.payButton
                    : cx(styles.payButton, styles.inactive)
                }
                disabled={!isAbleButton() || buttonLoading}
              >
                {buttonLoading ? (
                  <>
                    <span className={styles.loadingSpinner}></span>
                    PROCESSING...
                  </>
                ) : (
                  "PROCEED TO PAY"
                )}
              </button>
            </div>
            {/* <button className={cx(styles.payButton,styles.desktop)}>
                            PROCEED TO PAY
                        </button> */}
          </div>
        </div>
      </div>
      {(coupon || showCoupanPopUp) && (
        <CoupanPopUp
          appliedCoupon={appliedCoupon}
          toggleModal={toggleCoupanPopUp}
          toggleCoupanCongrats={toggleCoupanCongrats}
          cartData={cartData[0]}
        />
      )}

      {showCoupanCongratsPopUp && (
        <CouponCongrats
          appliedCoupon={appliedCoupon}
          toggleCoupanCongrats={toggleCoupanCongrats}
        />
      )}
    </>
  );
};
